import { Flex, Box, TextV2 } from '@withjoy/joykit';
import type { ProductAttributeSelectorProps } from '../config.types';
import type { Option } from '../product.types';
import React from 'react';
import { GenericChoiceGroupAttribute } from './GenericChoiceGroupAttribute';
import { DynamicStrikethrough } from './SimpleTextAttribute';

const SelectionOption = (props: { label: string; isPossible: boolean }) => {
  const { label, isPossible } = props;

  return (
    <Flex
      flex={1}
      height="100%"
      alignItems="center"
      justifyContent="flex-start"
    >
      <Box
        width="max-content"
        position="relative"
      >
        <DynamicStrikethrough show={!isPossible} />
        <TextV2
          typographyVariant="hed2"
          color="mono14"
        >
          {label}
        </TextV2>
      </Box>
    </Flex>
  );
};

export const ColumnTextAttribute = (props: ProductAttributeSelectorProps) => {
  const getOptionComponent = (option: Option, isPossible: boolean, index: number) => {
    return (
      <SelectionOption
        key={index}
        isPossible={isPossible}
        label={option.title}
      />
    );
  };

  const getChoiceGroupName = (option: Option) => {
    return option.title;
  };

  return (
    <GenericChoiceGroupAttribute
      {...props}
      hideValueFromTitle
      direction="column"
      minHeight={55}
      getOptionComponent={getOptionComponent}
      getChoiceGroupName={getChoiceGroupName}
    />
  );
};
